<template>
    <WizardShell :mission="mission">
        <!-- Édition du convoi -->
        <div class="row pt-1 mb-4 d-flex justify-content-center">
            <div class="col-12">
                <ConvoyListCompact v-if="!canEditConvoy" :mission="mission" />
                <ConvoyEditor v-else :mission="mission" @refresh="$emit('refresh')" />
            </div>
        </div>
        <template #actions>
            <ButtonDisplay @click="$emit('next')" :type="'start'" text="Suivant" />
        </template>
    </WizardShell>
</template>

<script>
import WizardShell from './WizardShell.vue'
import ConvoyEditor from '@/views/Missions/Components/Convoy/ConvoyEditor.vue'
import ConvoyListCompact from '@/views/Missions/Components/Convoy/ConvoyListCompact.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'

export default {
    name: 'WizardConvoi',
    props: ['mission'],
    components: { WizardShell, ConvoyEditor, ButtonDisplay, ConvoyListCompact },
    computed: {
        canEditConvoy() {
            const s = this.mission?.status;
            return !['FINISHED', 'CANCELED'].includes(s);
        }
    }
}
</script>